/** Serialize local auth mutations so late private responses cannot race explicit sign-in. */
export function createAuthQueue() {
  let tail: Promise<unknown> = Promise.resolve();
  return <T>(operation: () => Promise<T>): Promise<T> => {
    const run = () => typeof navigator !== 'undefined' && navigator.locks
      ? navigator.locks.request('halo-auth-mutations-v1', operation)
      : operation();
    const result = tail.then(run, run);
    tail = result.catch(() => {});
    return result;
  };
}

export type Reauthentication = { userId: string; token: string } | null;
export function rejectedCurrentSession(failedToken: string, session: { access_token: string; user: { id: string } } | null, before: number, after: number) {
  return !!session && session.access_token === failedToken && before === after;
}
export function needsReauthentication(required: Reauthentication, userId: string | undefined) {
  return !!required && required.userId === userId;
}

/** Match the original session after a token refresh, without targeting another sign-in. */
export function authSessionId(token: string): string | null {
  try {const value = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))); return typeof value.session_id === 'string' ? value.session_id : null;} catch {return null;}
}
export function sameAuthSession(original: {token: string | null; userId: string | null}, current: {access_token: string; user: {id: string}} | null) {
  if (!current || !original.token || current.user.id !== original.userId) return false;
  if (current.access_token === original.token) return true;
  const oldId = authSessionId(original.token), currentId = authSessionId(current.access_token);
  return !!oldId && oldId === currentId;
}
